import { render, staticRenderFns } from "./OrticFileUploadControl.vue?vue&type=template&id=13be14e0&scoped=true&"
import script from "./OrticFileUploadControl.vue?vue&type=script&lang=js&"
export * from "./OrticFileUploadControl.vue?vue&type=script&lang=js&"
import style0 from "./OrticFileUploadControl.vue?vue&type=style&index=0&id=13be14e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be14e0",
  null
  
)

export default component.exports